import React from "react";

const HorizontalProgressBar = ({ progress, label }) => {
    return (
        <div style={{ paddingLeft: '10px', paddingRight: '10px', width: "100%", marginBottom: "1rem" }}>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "0.5rem",
                    color: "#771615",
                }}>

                <span>{label}</span>
                <span>{`${progress}%`}</span>
            </div>
            <div
                style={{
                    height: "5px",
                    width: "100%",
                    backgroundColor: "#e0e0df",
                    borderRadius: "5px",
                    overflow: "hidden",
                }}>

                <div
                    style={{
                        height: "100%",
                        width: `${progress}%`,
                        backgroundColor: progress < 50 ? "#FF9800" : "#4caf50", // Color changes based on progress
                        transition: "width 0.3s ease-in-out",
                    }}
                ></div>
            </div>
        </div>
    );
};

export default HorizontalProgressBar;
